import { Allotment } from "allotment";
import { CommentPanelInner } from "components/common/comments/CommentPanel";
import ErrorBoundary from "components/common/ErrorBoundary";
import { HierarchyTopBar } from "components/hierarchypage/HierarchyTopBar";
import { TlfInner } from "components/tlfpage/Tlf";
import { TocTree } from "components/toc/TocTree";
import { BottomNav } from "components/topbar/BottomNav";
import { HierarchyContextProvider } from "contexts/HierarchyContextProvider";
import { TlfContextProvider } from "contexts/TlfContextProvider";
import { TocContextProvider } from "contexts/TocContextProvider";
import { TlfLoaderData } from "functions/api/tlfItem/tlfLoader";
import { useMemo } from "react";
import { Container } from "react-bootstrap";
import { Outlet, useLoaderData } from "react-router-dom";

/**
 * The TlfReview page
 */
export const TlfReview = (): React.ReactElement => (
  <ErrorBoundary>
    <HierarchyContextProvider>
      <TocContextProvider>
        <HierarchyTopBar />
        <div className="col-between-top-and-bottom">
          <Allotment defaultSizes={[1, 5]}>
            <Allotment.Pane>
              <div className="small-scrollbar col-between-top-and-bottom">
                <TocTree />
              </div>
            </Allotment.Pane>
            <Allotment.Pane>
              <Outlet />
            </Allotment.Pane>
          </Allotment>
        </div>
        <BottomNav />
      </TocContextProvider>
    </HierarchyContextProvider>
  </ErrorBoundary>
);

TlfReview.displayName = "TlfReview";

/**
 * Right hand side of the TlfReview page
 */
export const TlfReviewRHS = (): React.ReactElement => {
  const loaderData = useLoaderData() as TlfLoaderData;
  const tlfItem = useMemo(() => loaderData?.tlfItem, [loaderData?.tlfItem]);
  const isSubscribed = loaderData?.isTlfSubscribed;

  return !tlfItem ? (
    <div className="w-100 d-flex align-items-center justify-content-center">No Tlf loaded</div>
  ) : (
    <TlfContextProvider
      tlfData={tlfItem}
      readOnly
      isSubscribed={isSubscribed}
    >
      <Allotment defaultSizes={[4, 1]}>
        <Allotment.Pane>
          <div className="small-scrollbar col-between-top-and-bottom">
            <Container>
              <TlfInner />
            </Container>
          </div>
        </Allotment.Pane>
        <Allotment.Pane>
          <div className="small-scrollbar col-between-top-and-bottom">
            <CommentPanelInner activeContext="TlfItem" />
          </div>
        </Allotment.Pane>
      </Allotment>
    </TlfContextProvider>
  );
};

TlfReviewRHS.displayName = "TlfReviewRHS";

export default TlfReview;
